module.exports = __webpack_public_path__ + "static/self-delivery-6309601f52dd49981edecbfb0a871cb8.png";